import React, { useState } from "react"
import { Box, IconButton, Popover, Tooltip, Typography } from "@mui/material"
import { alpha } from "@mui/material/styles"
import { IconSeeker } from "@ui-seeker/core"

import { dsColorNew } from "@palette"


// An ⓘ beside a title that opens what the page or card is about, so the explanation is one click away
// instead of a paragraph above the content (the report form's "Num. searches" works the same way)
export default function AppInfoButton({ title, children, tooltip = 'What is this?', size = 22, sx = {} }) {
	const [anchor, setAnchor] = useState(null)

	return <>
		<Tooltip title={tooltip} arrow>
			<IconButton
				aria-label={tooltip}
				onClick={e => { e.stopPropagation(); setAnchor(e.currentTarget) }}
				sx={{
					width: size, height: size, p: 0, borderRadius: '6px', flexShrink: 0, verticalAlign: 'middle',
					color: anchor ? dsColorNew.appBlue : dsColorNew.textMuted,
					backgroundColor: anchor ? dsColorNew.hoverBgLight : 'transparent',
					'&:hover': { color: dsColorNew.appBlue, backgroundColor: dsColorNew.hoverBgLight },
					...sx,
				}}
			>
				<IconSeeker icon="circle-info" sx={{ fontSize: Math.round(size * 0.6) }}/>
			</IconButton>
		</Tooltip>
		<Popover
			open={!!anchor}
			anchorEl={anchor}
			onClose={() => setAnchor(null)}
			anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
			transformOrigin={{ vertical: 'top', horizontal: 'left' }}
			slotProps={{ paper: { sx: {
				mt: 0.75, maxWidth: 480, borderRadius: '12px', border: `1px solid ${dsColorNew.grayBorder}`,
				boxShadow: `0 16px 40px ${alpha(dsColorNew.navy, 0.16)}`, backgroundColor: dsColorNew.white,
			} } }}
		>
			{!!title && <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 2, pt: 1.5, pb: 0.75 }}>
				<IconSeeker icon="circle-info" sx={{ fontSize: 14, color: dsColorNew.appBlue }}/>
				<Typography sx={{ fontSize: 14, fontWeight: 600, color: dsColorNew.textTitle }}>{title}</Typography>
			</Box>}
			<Box sx={{
				px: 2, pt: title ? 0 : 1.5, pb: 1.75, fontSize: 13, lineHeight: 1.55, color: dsColorNew.textDark,
				display: 'flex', flexDirection: 'column', gap: 1,
				'& p': { m: 0 },
			}}>
				{children}
			</Box>
		</Popover>
	</>
}
